<template>
  <v-list v-bind="$attrs">
    <v-list-item v-for="item in flowItems" :key="item.id">
      <v-list-item-icon>
        <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
        <v-icon v-else-if="item.completed" color="success">
          $freshvuecard-process-completed
        </v-icon>
        <v-icon v-else-if="item.required" color="error">
          $freshvuecard-process-missing
        </v-icon>
        <v-icon v-else>$freshvuecard-process-uncompleted</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.name }}
          <v-chip
            v-if="item.required && !item.completed"
            color="error"
            class="ml-2"
            x-small
            label
          >
            fehlt
          </v-chip>
        </v-list-item-title>
        <slot :name="`item.${item.id}`">
          <v-list-item-subtitle v-if="item.children?.length > 0">
            {{ getItemChildrenSummary(item) }}
          </v-list-item-subtitle>
        </slot>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'ProcessFlowSummaryList',

  props: {
    flowItems: {
      type: Array,
      required: false,
      default: null
    }
  },

  methods: {
    getItemChildrenSummary(item) {
      return (
        item?.children
          ?.filter((i) => i.completed)
          ?.map((i) => i.name)
          ?.join(', ') ?? null
      )
    }
  }
}
</script>
